var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('badge',{class:{'liked': _vm.isLiked},attrs:{"icon":"heart"},on:{"click":_vm.toggleLike}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }